module.exports = __webpack_public_path__ + "img/leftBottom.1b3fbf36.png";